// extracted by mini-css-extract-plugin
module.exports = {"consulta-anomalias":"anomalias_consulta-anomalias__2WEW4"};